import { DescriptionContent } from '../models/Episode';

function renderContentsToText(contents: DescriptionContent[]) {
  if (!contents) return '';
  let html = '';
  if (contents.length > 0) {
    contents.map((c) => {
      if (!c || !c.value) return;
      c.value = c.value.replace(/<\/?[^>]+(>|$)/g, '');
      html += c.value;
    });
  }
  return html;
}

function replaceAll(str, match, replacement) {
  return str.replace(new RegExp(escapeRegExp(match), 'g'), () => replacement);
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export default renderContentsToText;
